import { useEffect, useState } from "react";
import { cn } from "~/lib/utils";

interface TopProgressBarProps {
  delay?: number;
}

export const TopProgressBar = ({ delay = 150 }: TopProgressBarProps) => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const delayTimer = window.setTimeout(() => {
      setVisible(true);
      setProgress(30);
    }, delay);
    return () => window.clearTimeout(delayTimer);
  }, [delay]);

  useEffect(() => {
    if (!visible) return;
    const trickle = window.setInterval(() => {
      setProgress((p) => (p >= 90 ? p : p + Math.max(0.5, (90 - p) * 0.1)));
    }, 300);
    return () => window.clearInterval(trickle);
  }, [visible]);

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-x-0 top-0 z-50 h-0.5 overflow-hidden",
        visible ? "opacity-100" : "opacity-0"
      )}
      aria-hidden="true"
    >
      <div
        className="h-full bg-primary transition-[width] duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
